import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "pl-4 lg:pl-20 py-14 font-poppins" }
const _hoisted_3 = { class: "m-0 pl-4" }
const _hoisted_4 = { class: "m-0 pl-4" }

import { ref, onMounted, onUnmounted } from 'vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import Accordion from '@/components/library/Accordion.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Dfsv',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();

const heroRef = ref<HTMLElement | null>(null);
const pastHeader = ref(false);

let observer: IntersectionObserver | null = null;

onMounted(() => {
  if (heroRef.value) {
    observer = new IntersectionObserver(
      ([entry]) => { pastHeader.value = !entry.isIntersecting; },
      { threshold: 0 }
    );
    observer.observe(heroRef.value);
  }
});

onUnmounted(() => {
  observer?.disconnect();
});

function quickExit () {
  window.location.replace('https://recipetineats.com');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "quick-exit" }, {
      default: _withCtx(() => [
        (pastHeader.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "fixed top-16 right-4 z-50 flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-poppins font-semibold text-sm px-4 py-2 rounded-full shadow-lg transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-red-600",
              "aria-label": "Quick exit — leave this page immediately",
              onClick: quickExit
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
                _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
                _createElementVNode("line", {
                  x1: "21",
                  y1: "12",
                  x2: "9",
                  y2: "12"
                })
              ], -1),
              _createTextVNode(" Quick Exit ")
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      ref_key: "heroRef",
      ref: heroRef,
      class: "w-full bg-legal"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "py-20 px-4 lg:px-24" }, [
        _createElementVNode("h1", { class: "font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28" }, "Domestic, Family and Sexual Violence Support"),
        _createElementVNode("div", { class: "w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md border-none hover:border-solid hover:border-2 hover:border-white hover:text-white" }, [
          _createElementVNode("button", {
            class: "flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer",
            onclick: "javascript:window.location.replace('https://recipetineats.com')"
          }, [
            _createElementVNode("a", {
              class: "no-underline text-black",
              href: "https://recipetineats.com/"
            }, "Quick Exit")
          ])
        ])
      ], -1)
    ]), 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "pb-2" }, [
            _createElementVNode("a", {
              href: "/",
              class: "text-primary"
            }, "< Back to home ")
          ], -1)),
          _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "font-poppins-bold" }, "Support Contact Details", -1)),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-bold my-0" }, " If you are in immediate danger, call emergency services on 000. ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-0 mb-5" }, " If you are experiencing domestic, family or sexual violence, Nexee is here to support you. ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-bold pb-0 my-0" }, " How to contact us ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-0 mb-1" }, " You can contact us for confidential assistance during business hours: ", -1)),
            _createElementVNode("p", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Phone:", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(brandService).getSupportPhoneNumber()), 1)
            ]),
            _createElementVNode("p", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Email:", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(brandService).getSupportEmail()), 1)
            ]),
            _cache[8] || (_cache[8] = _createStaticVNode("<p class=\"mb-0\" data-v-4daaa11f> Accessibility support is available: <ul class=\"list-disc my-0\" data-v-4daaa11f><li class=\"my-0\" data-v-4daaa11f>National Relay Service: via the Access Hub</li><li data-v-4daaa11f>Interpreting services: Translating and Interpreting Service (TIS National) on 131 450</li></ul></p><p class=\"mb-5\" data-v-4daaa11f> You can request a call-back and let us know your preferred and safest way to communicate. </p><p class=\"font-bold my-0 py-0\" data-v-4daaa11f> External support services </p><p class=\"my-0 py-0\" data-v-4daaa11f> You can also access free, confidential support from specialist services, including: <ul class=\"list-disc my-0 py-0\" data-v-4daaa11f><li data-v-4daaa11f><strong data-v-4daaa11f>1800RESPECT</strong> – 1800 737 732 (24/7 counselling and support)</li><li data-v-4daaa11f><strong data-v-4daaa11f>Full Stop Australia </strong>– 1800 385 578 (24/7 sexual, domestic and family violence support)</li><li data-v-4daaa11f><strong data-v-4daaa11f>Lifeline </strong>– 13 11 14 (24/7 crisis support)</li><li data-v-4daaa11f><strong data-v-4daaa11f>13YARN</strong> – 13 92 76 (24/7 First Nations support)</li></ul></p>", 4))
          ]),
          _createVNode(Accordion, { title: 'Our Domestic, Family and Sexual Violence Statement' }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("p", { class: "font-bold pt-4" }, " Our commitment to your safety ", -1),
              _createElementVNode("p", { class: "mb-5" }, " Uniti Retail Pty Ltd (ACN 154 074 218), trading as Nexee Internet, has policies and procedures in place to protect the safety, privacy and wellbeing of customers affected by domestic and family violence or non-domestic sexual violence. ", -1),
              _createElementVNode("p", { class: "mb-5" }, " We recognise that access to safe and reliable telecommunications is essential for safety, connection and recovery. We are committed to supporting affected persons in a respectful, trauma-informed way and to keeping customers connected to their services wherever possible. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Keeping you connected ", -1),
              _createElementVNode("p", { class: "mb-5" }, " If your telecommunications service has been restricted, suspended or disconnected and you tell us, this raises concerns about your safety. We will act as a matter of urgency to reverse that action. If reversal is not practical, we will offer an equivalent telecommunications service where available. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Financial hardship support ", -1),
              _createElementVNode("p", { class: "mb-5" }, " We recognise that domestic, family or sexual violence can be a reason for non-payment. Customers affected by DFSV may be entitled to financial hardship assistance under the Telecommunications (Financial Hardship) Standard 2024. We will work with you to discuss available support options. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " How we can support you ", -1),
              _createElementVNode("p", { class: "mb-5" }, [
                _createTextVNode(" With your consent, we can provide additional support which may include: "),
                _createElementVNode("ul", { class: "list-disc" }, [
                  _createElementVNode("li", null, "agreeing on a safe way and time to contact you"),
                  _createElementVNode("li", null, "applying a confidential DFSV safety flag to your account"),
                  _createElementVNode("li", null, "taking extra steps to protect access to your personal information"),
                  _createElementVNode("li", null, "reviewing fees, charges or credit actions that may affect your safety")
                ]),
                _createTextVNode(" You do not need to share details of the violence to receive support. ")
              ], -1),
              _createElementVNode("p", { class: "mb-5" }, " You can contact us or external support services via the details above. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Further information ", -1),
              _createElementVNode("p", { class: "mb-5" }, [
                _createTextVNode(" Our "),
                _createElementVNode("a", {
                  href: `/family-violence`,
                  class: "text-primary",
                  target: "_blank"
                }, "DFSV Customer Policy"),
                _createTextVNode(" provides more detail about how we support customers experiencing domestic, family or sexual violence and is available on our website. ")
              ], -1)
            ])),
            _: 1,
            __: [9]
          }),
          _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-primary text-left pt-5 font-poppins-bold" }, [
            _createElementVNode("a", {
              href: `/family-violence`,
              class: "text-primary",
              target: "_blank"
            }, "Nexee's Domestic, Family and Sexual Violence Policy")
          ], -1))
        ])
      ])
    ])
  ], 64))
}
}

})